import type { SVGProps } from 'react';
const DawnFlagVU = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-VU_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-VU_svg__a)">
      <g filter="url(#dawn-flag-VU_svg__b)">
        <path fill="#009543" fillRule="evenodd" d="M0 16h22V9.6H0z" clipRule="evenodd" />
      </g>
      <g filter="url(#dawn-flag-VU_svg__c)">
        <path fill="#D21034" fillRule="evenodd" d="M0 6.4h22V0H0z" clipRule="evenodd" />
      </g>
      <path fill="#262626" fillRule="evenodd" d="M0 9.6h22V6.4H0z" clipRule="evenodd" />
      <path
        fill="#262626"
        fillRule="evenodd"
        d="m0 0 10.476 8L0 16z"
        clipRule="evenodd"
      />
      <path stroke="#FDCE12" strokeWidth={1.333} d="M-.381 13.616V2.384L7.255 8z" />
      <path
        fill="#FDCE12"
        fillRule="evenodd"
        d="M7.333 8.533H22V7.467H7.333z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <filter
        id="dawn-flag-VU_svg__b"
        width={22}
        height={6.4}
        x={0}
        y={9.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_1910" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_1910" result="shape" />
      </filter>
      <filter
        id="dawn-flag-VU_svg__c"
        width={22}
        height={6.4}
        x={0}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_1910" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_1910" result="shape" />
      </filter>
    </defs>
  </svg>
);
export default DawnFlagVU;
